import {
  timeSlotsList,
  technicianAvailabiltyList,
} from "constants/techncianAvailabilty";
const initialState = {
  timeSlotsList: {},
  technicianAvailabiltyList: {},
};

const technicianAvailability = (state = initialState, action) => {
  switch (action.type) {
    case technicianAvailabiltyList:
      return { ...state, technicianAvailabiltyList: action.payload };
    case timeSlotsList:
      return { ...state, timeSlotsList: action.payload };
    default:
      return state;
  }
};

export default technicianAvailability;
